<script lang="ts">
  import { SearchMode } from "app/search/SearchControllers";
  import SearchResults from "app/search/SearchResults.svelte";

  import type { CombinedSearchResult } from "module/fakeSearchData";

  let {
    results,
    selectedIndex = results.length - 1,
    searchMode = SearchMode.DOCUMENT,
  }: {
    results: CombinedSearchResult[];
    selectedIndex?: number;
    searchMode?: SearchMode;
  } = $props();
</script>

<div class="example-results">
  <SearchResults
    embedded
    {searchMode}
    {results}
    {selectedIndex}
    selectedAction=""
    callAction={() => {}}
  />
  <span class="notes"><slot /></span>
</div>

<style>
  .example-results {
    overflow: hidden;
    display: flex;
    flex-shrink: 0;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    width: 275px;
    margin-top: 1em;
  }
  .example-results :global(.quick-insert-result) {
    border-radius: 4px;
    border: 1px solid #7a7971;
    width: 275px;
    background: var(--qiBackground);
  }

  /* Dorako UI compatibility */
  :global([data-theme].application)
    .example-results
    :global(.quick-insert-result) {
    background: var(--app-background);
    border: var(--app-border-width) solid var(--app-border-color);
  }
  .example-results .notes {
    text-align: center;
  }
</style>
